import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ContentLayout, StepperCard } from '@ibk/shared-layout';
import { useTranslation } from '@ibk/shared-translation';
import { NewRechargeStep, NewRechargeStepStatus } from '../../types';
import { NewRechargeSidebar } from '../NewRechargeSidebar';
import styles from './Payment.module.css';
export function Payment({ currentStep, formData, onComplete, onReturn, onStepChange }) {
    const { t } = useTranslation();
    const breadcrumbs = [
        { label: t('recharge.breadcrumb.benefits'), href: '/beneficios' },
        { label: t('recharge.breadcrumb.new-recharge'), isActive: true },
    ];
    const currentStepConfig = {
        id: NewRechargeStep.PAYMENT,
        title: t('recharge.step.payment'),
        number: 5,
        status: NewRechargeStepStatus.ACTIVE,
    };
    const renderMainCard = () => (_jsx(StepperCard, { currentStep: currentStepConfig, actions: {
            back: {
                label: t('payment.button.back'),
                onClick: onReturn,
            },
            next: {
                label: t('payment.button.complete'),
                onClick: onComplete,
                disabled: false,
            },
        }, "data-testid": 'payment-stepper-card', children: _jsxs("div", { className: styles.content, children: [_jsx("h2", { className: styles.title, children: t('payment.title') }), _jsx("p", { className: styles.subtitle, children: t('payment.subtitle') }), _jsxs("div", { className: styles.placeholder, children: [_jsx("div", { className: styles.placeholderIcon, children: "\uD83D\uDCB3" }), _jsx("div", { className: styles.placeholderText, children: t('payment.placeholder.message') })] })] }) }));
    const renderSummaryCard = () => (_jsx(NewRechargeSidebar, { currentStep: currentStep, formData: formData, onStepChange: onStepChange }));
    return (_jsx(ContentLayout, { breadcrumbs: breadcrumbs, sidebar: renderSummaryCard(), children: renderMainCard() }));
}
